import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getTimeSyncInfo } from '../store/selectors/getDynamicFieldView';
import StreamSyncController from '../utils/StreamSyncController';

const PlayTimeStampSyncController = forwardRef(({ player, playEndTime, syncMode }, timestamp) => {
    const { playTimeStamp, syncingThresholds: { ahead, behind } } = useSelector(getTimeSyncInfo);
    const playTimeEndStamp = playEndTime || playTimeStamp;
    const controllerRef = useRef(new StreamSyncController(playTimeEndStamp, player, ahead, behind, syncMode));

    useEffect(() => {
        return () => {
            if (controllerRef.current?.destroy) {
                controllerRef.current.destroy();
            }
            controllerRef.current = null;
        };
    }, []);

    useEffect(() => {
        if (player.current && controllerRef.current) {
            controllerRef.current.updateTimeStamp(playTimeEndStamp);
            controllerRef.current.manageStream();
        }
    }, [playTimeEndStamp, controllerRef]);

    useImperativeHandle(timestamp, () => {
        return controllerRef.current;
    }, [controllerRef]);

    return null;
});

PlayTimeStampSyncController.displayName = 'PlayTimeStampController';

PlayTimeStampSyncController.propTypes = {
    player: PropTypes.object,
    playEndTime: PropTypes.any,
    syncMode: PropTypes.string
};

export default PlayTimeStampSyncController;
